const features = [
  {
    icon: 'ri-4k-fill',
    title: '4K蓝光画质',
    desc: '海量资源支持4K超高清和蓝光原画播放，每一帧画面都纤毫毕现，为您呈现影院级的视觉盛宴。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告纯净观影',
    desc: '全程零广告干扰，拒绝片头等待和片中弹窗，让您沉浸在纯粹的影视世界中不受打扰。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '先进的CDN加速和智能码率自适应技术，无论网络环境如何，都能确保播放稳定流畅。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日海量更新',
    desc: '每日更新海量热门电影、电视剧、动漫和综艺资源，与全网同步，精彩内容永远看不完。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">平台优势</h2>
          <p className="mt-3 text-sm text-foreground-500">为什么选择蘑菇影视？</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center group hover:border-accent-300/50 transition-colors cursor-pointer">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${f.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}